module.exports = __webpack_public_path__ + "static/media/accidentEmergency.f2069cfc.svg";